import { TPaymentMethodEnum } from "../types/Product"

export const paymentMethodImmediatePurchase = [
  TPaymentMethodEnum.CreditCard,
  TPaymentMethodEnum.DebitCard,
  TPaymentMethodEnum.TwoCreditCard,
]

export const paymentMethodNonImmediatePurchase = [
  TPaymentMethodEnum.Pix,
  TPaymentMethodEnum.Boleto,
  TPaymentMethodEnum.CreditCardAndPix,
]
